export const centeredContainerStyle = {
  width: '100%',
  height: 242,
  borderColor: 'divider',
  borderRadius: '10px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 2,
  margin: '0 auto'
};

export const locationCardStyle = {
  width: `calc(50% - 8px)`,
  minHeight: 280,
  borderRadius: '10px',
  border: '1px solid',
  p: 0,
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  borderColor: 'divider',
  boxShadow: '0px 1px 3px rgba(0,0,0,0.1)'
};

export const emptyStateContainerStyle = {
  width: '100%',
  height: 120,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 1.5,
  borderColor: 'divider',
  borderRadius: 2,
  mt: 1,
  px: 2
};
